module.exports = __webpack_public_path__ + "static/media/Sub 14.06eae63b.JPG";